import { HiArrowNarrowRight } from "react-icons/hi";
import "../../styles/code/TalentLaunchSection.css";

const cardData = [
  {
    image: "/images/code/talent/talent1.webp",
    title: "Khóa học Marketing Fullstack",
    link: "#",
  },
  {
    image: "/images/code/talent/talent2.webp",
    title: "Khóa học lập trình web Full-Stack",
    link: "#",
  },
  {
    image: "/images/code/talent/talent3.webp",
    title: "Khóa học UI/UX từ cơ bản đến nâng cao",
    link: "#",
  },
];

function TalentLaunchSection() {
  return (
    <section className="talent-section">
      <div className="talent-heading">
        <h2 className="talent-heading__text">
          <span className="talent-heading__normal">Bệ phóng</span>
          <span className="talent-heading__highlight">nhân tài</span>
          <span className="talent-heading__highlight--age">
            18 tuổi trở lên
          </span>
        </h2>
        <p className="talent-heading__description">
          Chinh phục những kỹ năng mới để xây dựng lợi thế cạnh tranh trên thị
          trường lao động. Sẵn sàng bắt đầu sự nghiệp mơ ước chỉ trong 6 - 8
          tháng.
        </p>
      </div>

      <div className="talent-section__cards">
        {cardData.map((card, index) => (
          <div
            className="talent-card"
            key={index}
          >
            <div className="talent-card__image">
              <img
                src={card.image}
                alt={card.title}
              />
            </div>
            <h3 className="talent-card__title">{card.title}</h3>
            <a
              href={card.link}
              className="talent-card__button"
            >
              <span className="talent-card__button-icon-wrapper">
                <HiArrowNarrowRight className="talent-card__button-icon" />
              </span>
              <span className="talent-card__button-text">Xem chi tiết</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TalentLaunchSection;
